import type { GridDimensions } from "@mui/x-data-grid-premium";

import type {
  GridTreeNode,
  GridGroupNode,
  GridLeafNode,
} from "@mui/x-data-grid-premium";
export const isGroupNode = (node: GridTreeNode): node is GridGroupNode => {
  return node.type === "group";
};
export const isLeafNode = (node: GridTreeNode): node is GridLeafNode => {
  return node.type === "leaf";
};
export const isLastRowInGroup = (
  parentRowNode: GridGroupNode,
  rowNode: GridLeafNode,
) => {
  const groupLastRowId =
    parentRowNode.children[parentRowNode.children.length - 1];
  return groupLastRowId === rowNode.id;
};

export const computePageSize = (dimensions: GridDimensions) => {
  return Math.floor(dimensions.viewportInnerSize.height / dimensions.rowHeight);
};
